import { useTitle } from '../hooks';
import { Typography, Box } from '@mui/material';
import colors from '../assets/colors';

function NotFound() {
  useTitle('AgroWe-404');
  return (
    <Box
      sx={{
        background: colors.white,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          width: '50%',
          height: '70%',
          backgroundSize: 'cover',
          backgroundPosition: 'top',
        }}
      >
        <Box sx={{ marginTop: '10vh', marginBottom: 48 }}>
          <Typography
            variant="h2"
            sx={{
              opacity: 0.64,
              color: colors.oldAgroweGreen,
              fontSize: 72,
              fontWeight: 'bold',
              letterSpacing: '0.2px',
              lineHeight: '2.25rem',
              textAlign: 'center',
              mb: 8,
            }}
          >
            404
          </Typography>
          <Typography
            sx={{
              mt: '8vh',
              opacity: 0.56,
              color: colors.oldAgroweGreen,
              fontSize: 46,
              letterSpacing: '0.17px',
              textAlign: 'center',
            }}
          >
            Page not found
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default NotFound;
